import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Provider, Type } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TranslatePipe } from '@ngx-translate/core';
import { ShIconModule } from '../../elements/components/icon/icon.module';
import { SearchPageStateService } from '../../overviews/search-page/state-machines/search-page-state.service';
import { ShToastFactory, ShToastModule } from '../../toasts/toast.module';
import { ShAbstractHttpService } from '../http/services/http.abstract.service';
import { ShUrlQueryService } from '../query/services/url-query.service';
import { ShRecordRestrictionService } from '../records/services/restrictions/record-restriction.service';

export const CORE_APP_MODULES = [
    // Core Angular modules
    BrowserModule,
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,

    // Library modules
    ShIconModule.forRoot(),
    ShToastModule
];

@NgModule({
    imports: [],
    declarations: [],
    exports: []
})
export class ShCoreAppModule {
    static forRoot(httpService: Type<ShAbstractHttpService>): ModuleWithProviders<ShCoreAppModule> {
        const providers: Provider[] = [
            // Core app services
            ShRecordRestrictionService,
            ShToastFactory,
            ShUrlQueryService,
            SearchPageStateService,

            // Overrides
            { provide: ShAbstractHttpService, useClass: httpService },

            // Pipes
            DatePipe,
            TranslatePipe,

            // Other
            provideAnimations()
        ];

        return {
            ngModule: ShCoreAppModule,
            providers
        };
    }
}
